<template>
  <base-layout>
    <v-row>
      <v-col
        sm="12"
        md="6"
        cols="12">
        <v-row>
          <v-col
            md="4"
            cols="6">
            Spending
          </v-col>
          <v-col
            md="4"
            cols="3">
            <v-text-field
              v-model="spendingRange[0]"
              dense
              label="Min"
            />
          </v-col>
          <v-col
            md="4"
            cols="3">
            <v-text-field
              v-model="spendingRange[1]"
              dense
              label="Max"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-select
              v-model="selectMemberType"
              :items="memberTypeItems"
              label="Member Type"
            />
          </v-col>
          <v-col cols="6">
            <v-select
              v-model="selectMonth"
              :items="monthItems"
              label="Birth Month"
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col
        sm="12"
        md="6"
        cols="12">
        <v-row>
          <v-col
            md="10"
            sm="10"
            cols="9">
            <v-text-field
              v-model="searchText"
              dense
              label="Search"
              @keydown.enter="searchItem"
            />
          </v-col>
          <v-col
            md="2"
            sm="2"
            cols="3"
            class="text-center">
            <v-btn
              outlined
              small
              color="primary"
              @click="searchItem()">
              Find
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <paginate
      :page="parseInt(page)"
      :per-page="perPage"
      :total="total"
      @on-page-change="changePage" />
    <data-table :items="data" />
  </base-layout>
</template>

<script>
import { mapActions } from 'vuex'
import MemberProvider from '@/resources/MemberProvider'
import Paginate from '@/components/Paginate'
import Table from '../components/Table.vue'

const memberService = new MemberProvider()
export default {
  components: {
    Paginate,
    dataTable: Table
  },
  data () {
    return {
      data: [],
      memberTypeItems: [
        { text: 'All', value: '' },
        { text: 'VIP', value: 'vip' },
        { text: 'Normal', value: 'normal' }
      ],
      monthItems: [
        { text: 'All', value: '' },
        { text: 'January', value: '01' },
        { text: 'February', value: '02' },
        { text: 'March', value: '03' },
        { text: 'April', value: '04' },
        { text: 'May', value: '05' },
        { text: 'June', value: '06' },
        { text: 'July', value: '07' },
        { text: 'August', value: '08' },
        { text: 'September', value: '09' },
        { text: 'October', value: '10' },
        { text: 'November', value: '11' },
        { text: 'December', value: '12' }
      ],
      selectMemberType: '',
      selectMonth: '',
      perPage: 15,
      total: 0,
      searchText: '',
      spendingMin: 0,
      spendingRange: [0, 300000]
    }
  },
  computed: {
    page () {
      return this.$route.query.page ? this.$route.query.page : 1
    },
    search () {
      return this.$route.query.search ? this.$route.query.search : ''
    },
    min () {
      return this.$route.query.min ? parseInt(this.$route.query.min, 10) : this.spendingMin
    },
    max () {
      return this.$route.query.max ? parseInt(this.$route.query.max, 10) : this.spendingMax
    },
    type () {
      return this.$route.query.type ? this.$route.query.type : ''
    },
    month () {
      return this.$route.query.month ? this.$route.query.month : ''
    }
  },
  async created () {
    this.$router.replace({
      name: this.$route.name,
      query: {
        page: this.$route.query.page ? this.$route.query.page : 1,
        search: this.$route.query.search ? this.$route.query.search : '',
        type: this.$route.query.type ? this.$route.query.type : this.selectMemberType,
        month: this.$route.query.month ? this.$route.query.month : this.selectMonth,
        min: this.$route.query.min ? this.$route.query.min : this.spendingRange[0],
        max: this.$route.query.max ? this.$route.query.max : this.spendingRange[1]
      }
    }).catch(() => {})
    this.searchText = this.search
    this.spendingRange[0] = this.min
    this.spendingRange[1] = this.max
    this.selectMonth = this.month
    this.selectMemberType = this.type
    await this.getData()
  },
  methods: {
    ...mapActions({
      setLoading: 'Style/setLoading',
      setSnackbar: 'Style/setSnackbar'
    }),
    searchItem () {
      this.$router.replace({
      name: this.$route.name,
      query: {
        page: 1,
        search: this.searchText,
        type: this.selectMemberType,
        month: this.selectMonth,
        min: this.spendingRange[0],
        max: this.spendingRange[1]
      }
    }).catch(() => {})
    },
    changePage (page) {
      this.$router.replace({
        name: this.$route.name,
        query: {
          page,
          search: this.$route.query.search,
          type: this.selectMemberType,
          month: this.selectMonth,
          min: this.spendingRange[0],
          max: this.spendingRange[1]
        }
      }).catch(() => {})
    },
    formatTel (search) {
      if (search.charAt(0) !== '0') {
        return search
      }
      return `66${search.substring(1, search.length)}`
    },
    async getData () {
      await this.setLoading({
        active: true,
        clickAble: false,
        message: 'Getting member.'
      })
      try {
        // eslint-disable-next-line max-len
        const query = `?page=${this.page}&limit=${this.perPage}&search=${this.formatTel(this.search)}&type=${this.type}&birth_month=${this.month}&spending_min_price=${this.min}&spending_max_price=${this.max}`
        const result = await memberService.getMember(query)
        this.total = result.data.total
        this.data.push(...result.data.results)
      } catch (err) {
        this.setSnackbar({
          message: err.message,
          type: 'pink',
          timeout: 3000,
          canClose: true,
          value: true
        })
      } finally {
        await this.setLoading({
          active: false,
          clickAble: false,
          message: 'Getting member.'
        })
      }
    }
  }
}
</script>
